import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { first, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RilievoDTO } from '../models/models/pages/rilevamento';

@Injectable({ providedIn: 'root' })
export class RilevamentoService {
    private baseUrl = `${environment.baseApiUrl}/rilevamento`;

    constructor(private http: HttpClient) {}

    // LIST
    list(params?: { page?: number; size?: number; sort?: string }): Observable<RilievoDTO[]> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);

        return this.http.get<RilievoDTO[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true
        });
    }

    // GET by id
    get(id: number): Observable<RilievoDTO[]> {
        return this.http.get<RilievoDTO[]>(`${this.baseUrl}/${id}`, { withCredentials: true }).pipe(first());
    }

    // CREATE
    create(payload: any): Observable<RilievoDTO> {
        return this.http.post<RilievoDTO>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE
    update(id: any, entity: RilievoDTO): Observable<RilievoDTO> {
        return this.http.put<RilievoDTO>(`${this.baseUrl}/${id}`, entity, { withCredentials: true });
    }

    // PATCH
    partialUpdate(id: number, patch: Partial<RilievoDTO>): Observable<RilievoDTO> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<RilievoDTO>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    // DELETE
    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }
}
